import AutoReplace from 'slate-auto-replace';
import isHotkey from 'is-hotkey';
import BlockTypes, { VOID_BLOCKS } from '../../types/BlockTypes';

function makeDefaultOnApply(type) {
  return function makeMarkdownBlockShortcutOnApply(editor, event, matches) {
    if (VOID_BLOCKS.includes(type)) {
      var key = editor.value.startBlock.key;
      editor.splitBlock().setBlocks(BlockTypes.UNSTYLED).setNodeByKey(key, type);
    } else {
      editor.setBlocks(type);
    }

    return editor.focus();
  };
}

export default function makeMarkdownBlockShortcut(regexp, type) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$triggers = _ref.triggers,
      triggers = _ref$triggers === void 0 ? ['shift?+space'] : _ref$triggers,
      _ref$onlyOnBlocksOfTy = _ref.onlyOnBlocksOfTypes,
      onlyOnBlocksOfTypes = _ref$onlyOnBlocksOfTy === void 0 ? [BlockTypes.UNSTYLED] : _ref$onlyOnBlocksOfTy,
      onApply = _ref.onApply;

  var shortcutHotkeys = triggers.map(function (hotkey) {
    return isHotkey(hotkey);
  });
  return AutoReplace({
    trigger: function trigger(event, editor) {
      var _editor$value = editor.value,
          startText = _editor$value.startText,
          startBlock = _editor$value.startBlock;
      if (!startBlock || !startText) return false;
      if (onlyOnBlocksOfTypes && !onlyOnBlocksOfTypes.includes(startBlock.type) || startBlock.type === BlockTypes.CODE) return false;
      if (startBlock.getOffset(startText.key) !== 0) return false;
      return Boolean(shortcutHotkeys.find(function (isShortcutHotkey) {
        return isShortcutHotkey(event);
      }));
    },
    before: regexp,
    change: onApply || makeDefaultOnApply(type)
  });
}